// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { registerNamespace } from '@/lib/i18n-namespace';
import en from '@/locales/en/watchlist.json';
import ar from '@/locales/ar/watchlist.json';

/** Namespace of the attendance watchlist and observations (workforce controls §6); imported by every module that renders its strings. */
export const WATCHLIST_NS = 'watchlist';
registerNamespace(WATCHLIST_NS, en, ar);
